import { useState } from "react";

export const useAccordion = (initialExpanded: string[] = []) => {
  const [expanded, setExpanded] = useState<string[]>(initialExpanded);

  const handleAccordionChange =
    (panel: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded((prevExpanded) => {
        if (isExpanded) {
          return [...prevExpanded, panel];
        } else {
          return prevExpanded.filter((id) => id !== panel);
        }
      });
    };

  return { expanded, setExpanded, handleAccordionChange };
};
